import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "workflowRefus"
};
const _hoisted_2 = {
  class: "blocRefus"
};
const _hoisted_3 = {
  class: "blocText"
};
const _hoisted_4 = {
  class: "refus"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "raisonRefus"
};
const _hoisted_7 = {
  class: "dateRefus"
};
const _hoisted_8 = {
  class: "date"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "blocIconeGroupe"
  }, [_createElementVNode("div", {
    class: "logoGroupe"
  })], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, [_createElementVNode("span", {
    innerHTML: _ctx.$t('workflow.cour.rejection.popup.message', {
      groupName: _ctx.groupName,
      stepNumber: _ctx.stepNumber,
      stepsCount: _ctx.stepsCount
    })
  }, null, 8, _hoisted_5)]), _createElementVNode("p", _hoisted_6, [_cache[0] || (_cache[0] = _createElementVNode("span", null, "«", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.comment), 1), _cache[1] || (_cache[1] = _createElementVNode("span", null, "»", -1))]), _createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "pictoRefus"
  }, null, -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.dateFormatted), 1)])])])]);
}